import styled, { css } from "styled-components";

// ======================
// Funções auxiliares
// ======================

function getPositionGradient(position: number): string {
  switch (position) {
    case 1:
    case 2:
    case 3:
      return "linear-gradient(to bottom right, #3B82F6, #2563EB)";
    default:
      return "linear-gradient(to bottom right, #E5E7EB, #D1D5DB)";
  }
}

// ======================
// Layout Geral
// ======================

export const Content = styled.div`
  width: 100%;
  background-color: #f5f5f5;
`;

export const Container = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  width: 100%;
  /* Altura máxima para scroll interno */

  padding: 8px 16px 16px 16px;
  box-shadow: 0px 4px 4px 0px #00000040;
`;

// ======================
// Header
// ======================

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
`;

export const HeaderTitle = styled.h1`
  font-family: Inter;
  font-weight: 600;
  font-size: 24px;
  line-height: 29.05px;
  letter-spacing: -1%;
  background: linear-gradient(to right, #1f2937, #4b5563);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

// ======================
// Regionais (grid cards)
// ======================

export const RegionalsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  overflow-y: auto;
  max-height: 310px;
  overflow-x: hidden;

  /* Responsivo */
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

/** Card de cada Regional */
interface RegionalCardProps {
  isActive?: boolean;
}
export const RegionalCard = styled.div<RegionalCardProps>`
  border: 1px solid #e2e2e2;
  border-radius: 12px;
  overflow: hidden;

  /* Sombra padrão no card */
  box-shadow: 0px 4px 4px 0px #00000040;
  margin-bottom: 8px;
`;

export const RegionalCardHeader = styled.div`
  padding: 24px;
  /* Gradiente dinâmico */
  background: #f5f5f5;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RegionalLine: any = styled.div`
  width: 100%;
  height: 3px;
  background-color: ${(props: any) => props.corDestaque || "#bd1622"};
`;

export const RegionalIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: Inter;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: -1%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  background-color: #fff;
  border-radius: 50%;
  width: 80px;
  height: 80px;
`;

export const RegionalInfos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 8px;
  font-family: Inter;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: -1%;
`;

export const RegionalTextInfo = styled.p`
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: -1%;
  color: #646363;
`;

export const RegionalBandeiraImg = styled.img`
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  object-fit: cover;
`;

export const RegionalCardBody = styled.div`
  padding: 16px;
`;

export const Top3Item = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

interface PositionBadgeProps {
  position: number;
}
export const PositionBadge = styled.div<PositionBadgeProps>`
  width: 28px;
  height: 28px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: bold;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ position }) => getPositionGradient(position)};
`;

export const Avatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const RankInfo = styled.div`
  flex: 1;

  p {
    font-family: Inter;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: -1%;
    margin: 0;
  }

  span {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: -1%;
  }
`;

export const PointsInfo = styled.div`
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -1%;
  color: #4b5563;
`;

// ======================
// Botão fixo na parte de baixo
// ======================

/**
 * Wrapper "gruda" no final do container ao rolar,
 * graças ao position: sticky.
 */
export const BottomButtonWrapper = styled.div`
  position: sticky;
  bottom: 0;
  background-color: #ffffff;
  padding-top: 8px;
  display: flex;
  justify-content: center;
`;

/** Botão em si */
export const BottomButton = styled.a`
  text-align: center;
  width: 100%;
  border: 1px solid #1a49cc;
  background-color: #ffffff;
  color: #1a49cc;
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background-color: #f3f6ff;
  }
`;
